export const COLORS = {
  blue: "#E6ECF4",
  //
  orange: "#F87444",
  // text, headlines,
  black: "#3B3A40",
  darkGrey: "#3B3A40",
  lightGrey: "#EAEAEA",
  darkBlue: "#032A5D",
  lightOrange: "#FFF1EC",
}
// Blue - E6ECF4

// Orange - F87444

// Black - 3B3A40

// Dark grey - 9E9E9E

// Light Grey - EAEAEA

// Dark Blue - 032A5D

// Light Orange - FFF1EC
